<div class="content" margin-right-auto>
  <div layout layout-align-items-center>
    @if (record.symbol; as symbol) {
      <rt-symbol [symbol]="symbol" margin-right-small-x />
    }
    <rt-heading variant="heading large" margin-bottom-small-xx>
      <span class="template-name">{{ record.name }}</span>
    </rt-heading>
  </div>
  <div
    prosemirrorBasicConfig
    [prosemirrorRender]="
      !record.descriptionJson || record.descriptionJson.doc
        ? record.descriptionJson
        : { doc: record.descriptionJson }
    "
    [prosemirrorRenderConfig]="ProsemirrorBasicConfig"
    class="description-content"
  ></div>
</div>
<rt-button margin-left>
  <rt-icon name="add" />
  {{ 'tlc.ask_hr.user_requests.submit_request' | translate }}
</rt-button>
